import { ParentContext } from "components/constants/ParentContext";
import { Button } from "components/shadcn/ui/button";
import { getRedirectUrl } from "components/utils/getRedirectUrl";
import React, { useContext } from "react";

const UnauthLayout: React.FC = () => {
  const context = useContext<any>(ParentContext);

  const theme = context.isHarbour
    ? "harbour"
    : context.isBiz4Biz
    ? "biz4biz"
    : "bizcrunch";

  const handleLogin = () => {
    //handleMixpanelEvent("Login");
    const redirectUrl = getRedirectUrl(
      `${process.env.REACT_APP_CLERK_PRIMARY_APP_URL}/sign-in#/?redirect_url=${process.env.REACT_APP_CLERK_BUYER_APP_URL}`
    );
    window.location.href = redirectUrl;
  };

  return (
    <div className="m-6 flex justify-between items-center">
      <div className="flex flex-row gap-4 items-center">
        <img
          className="max-w-32 max-h-5"
          src={
            theme === "bizcrunch"
              ? "/assets/logo.png"
              : theme === "harbour"
              ? "/assets/logoHC.png"
              : "/assets/logoB4B.jpg"
          }
          alt="logo"
        />
        <Button variant="default">Search </Button>
      </div>
      <Button variant="primary" className="mt-5" onClick={handleLogin}>
        Sign in / Sign up
      </Button>
    </div>
  );
};

export default UnauthLayout;
